import { render, staticRenderFns } from "./YoukeRemenLuxian.vue?vue&type=template&id=046d1e99&scoped=true&"
import script from "./YoukeRemenLuxian.vue?vue&type=script&lang=js&"
export * from "./YoukeRemenLuxian.vue?vue&type=script&lang=js&"
import style0 from "./YoukeRemenLuxian.vue?vue&type=style&index=0&id=046d1e99&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d1e99",
  null
  
)

export default component.exports